<template>
    <div>
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaContabilizacion }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaContabilizacion" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="procesarContabilizacion">{{ labels.procesar }}</b-button>
        </div>
        <ConsultaContabilizacion :listContabilizacion="listaContabilizacion"></ConsultaContabilizacion>
    </div>
</template>

<script>
import ContratoContabilizacion from '../../services/ContratoContabilizacion'
import ConsultaContabilizacion from '../consultaCierres/ConsultaContabilizacion.vue'
export default {
    components: { ConsultaContabilizacion },
    name : 'Contabilizacion',
    data : () => ({
        fechaContabilizacion : '',
        listaContabilizacion : [],
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Contabilización',
                    fechaContabilizacion : 'Fecha contabilización',
                    procesar : 'Procesar'
                }
            }else{
                return {
                    title : 'Accounting',
                    fechaContabilizacion : 'Posting date',
                    procesar : 'Process'
                }
            }
        }
    },
    methods:{
        procesarContabilizacion(){
            const fecha = new Date
            const mes = fecha.getMonth() + 1
            const anio = fecha.getFullYear()
            const fechaActual = anio+'-0'+mes

            if(this.fechaContabilizacion == ''){
                this.$toast.error('Diligenciar la fecha contabilización.')

            }else if(this.fechaContabilizacion >= fechaActual){
                this.$toast.error('La fecha contabilización no puede ser igual o mayor al mes actual.')

            }else if(this.fechaContabilizacion != ''){

                let datos = {
                    'fechaContabilizacion' : this.fechaContabilizacion,
                    'idUser' : this.$store.state.userId
                }

                ContratoContabilizacion.createContabilizacion(datos)
                .then((res) => {
                    // console.log(res);
                    this.$toast.success(res.data.message)
                    this.consultaContabilizacion()
                }).catch((err) => {
                    if(err.response.status == 500){
                        this.$toast.error(err.response.data.error)
                    }else{
                        this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                });
            }
        },
        consultaContabilizacion(){
            ContratoContabilizacion.getContabilizacionByFechaContab(this.fechaContabilizacion)
            .then((res) => {
                // console.log(res.data.listContabilizacion);
                this.listaContabilizacion = res.data.listContabilizacion
            })
            .catch((error) => console.log(error))
        }
    }
}
</script>

<style>

</style>